import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';
import { noop } from '@synergy/utils';

import { OrderApproval, OrderApprovalItem } from './models/order-approval';

export class OrderApprovalsApi {
    constructor(protected baseUrl: string) {}

    public cget = (params: URLSearchParams): Promise<ApiResult<PaginatedResponse<OrderApproval>>> =>
        safeRequest(
            () => request.get(`${this.baseUrl}/pending-carts`, { params }),
            response => response.data
        );

    public getItems = (id: number): Promise<ApiResult<OrderApprovalItem[]>> =>
        safeRequest(
            () => request.get(`${this.baseUrl}/pending-carts/${id}/items`),
            response => response.data
        );

    public approve = (id: number): Promise<ApiResult<void>> =>
        safeRequest(() => request.post(`${this.baseUrl}/cart/${id}/approve`), noop);

    public decline = (id: number): Promise<ApiResult<void>> =>
        safeRequest(() => request.post(`${this.baseUrl}/cart/${id}/decline`), noop);
}
